/**
 * External dependencies
 */
import React from "react";
import { Box } from "@towersystems/towersystems-design-system";
import classNames from "classnames";
import { GoChevronLeft } from "react-icons/go";
import { GoChevronRight } from "react-icons/go";

/**
 * Internal dependencies
 */

/**
 * Style dependencies
 */
import "./sidebar.scss";

const Sidebar = ({ children, afterContent, spacing = "large" }) => {
  const [isOpen, setIsOpen] = React.useState(true);

  const handleOnClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Box
      className={classNames(
        "report-builder__sidebar-wrapper",
        isOpen && "is-open"
      )}
      background="card"
    >
      <Box className="report-builder__sidebar-toggle" onClick={handleOnClick}>
        {isOpen ? <GoChevronLeft size={25} /> : <GoChevronRight size={25} />}
      </Box>
      <Box className="report-builder__sidebar" padding={spacing}>
        <div className="report-builder__sidebar-content">{children}</div>
        {afterContent}
      </Box>
    </Box>
  );
};

export default Sidebar;
